import { useLocation, useParams } from 'react-router-dom'
import { PageParams } from './hooks.types'

export const useParamsOutSideRoutes = () => {
  const location = useLocation()
  const params = useParams()

  // Extract parameters from URL path matching the patterns we care about
  const extractParamsFromPath = (pathname: string) => {
    // Pattern: /plan/:planId/sourcesite/:sourcesiteId/workcentre/:workcentreId
    const workcentreMatch = pathname.match(
      /\/plan\/([^/]+)\/sourcesite\/([^/]+)\/workcentre\/([^/]+)/
    )
    if (workcentreMatch) {
      return {
        planId: workcentreMatch[1],
        sourcesiteId: workcentreMatch[2],
        workcentreId: workcentreMatch[3],
      }
    }

    // Pattern: /plan/:planId
    const planMatch = pathname.match(/\/plan\/([^/]+)/)
    if (planMatch) {
      return {
        planId: planMatch[1],
        sourcesiteId: '',
        workcentreId: '',
      }
    }

    // Default empty values for other routes
    return {
      planId: '',
      sourcesiteId: '',
      workcentreId: '',
    }
  }

  const extractedParams = extractParamsFromPath(location.pathname)

  // Merge with useParams for routes that are currently active
  const { workcentreId, planId, sourcesiteId } = {
    ...extractedParams,
    ...params,
  } as PageParams

  // We have the below condition to avoid network calls when we work on create-plan pages.
  const correctPlanId = planId === 'create-plan' ? '' : planId

  return {
    workcentreId: workcentreId ?? '',
    planId: correctPlanId ?? '',
    sourcesiteId: sourcesiteId ?? '',
  }
}
